var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8 14.25C15.2625 14.25 14.5232 15 12 15C9.47679 15 8.74286 14.25 7.2 14.25C3.225 14.25 0 17.0719 0 20.55V21.75C0 22.9922 1.15179 24 2.57143 24H21.4286C22.8482 24 24 22.9922 24 21.75V20.55C24 17.0719 20.775 14.25 16.8 14.25ZM21.4286 21.75H2.57143V20.55C2.57143 18.3188 4.65 16.5 7.2 16.5C7.98214 16.5 9.25179 17.25 12 17.25C14.7696 17.25 16.0125 16.5 16.8 16.5C19.35 16.5 21.4286 18.3188 21.4286 20.55V21.75ZM12 13.5C16.2589 13.5 19.7143 10.4766 19.7143 6.75C19.7143 3.02344 16.2589 0 12 0C7.74107 0 4.28571 3.02344 4.28571 6.75C4.28571 10.4766 7.74107 13.5 12 13.5ZM12 2.25C14.8339 2.25 17.1429 4.27031 17.1429 6.75C17.1429 9.22969 14.8339 11.25 12 11.25C9.16607 11.25 6.85714 9.22969 6.85714 6.75C6.85714 4.27031 9.16607 2.25 12 2.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.9c14538e45d1030e7be88ea1ae0225f6.svg";
export { ForwardRef as ReactComponent };